import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import type {
    CommandFooterDynamicStyleType
} from "../../type";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 0
    },
    hint: {
        flexDirection: "row",
        alignItems: "center"
    },
    end: {
        marginStart: "auto"
    }
});

export const useStyles = ({
    controlPaddings,
    controlHeights,
    borders,
    variant,
    colors,
    spaces
}: CommandFooterDynamicStyleType) => {
    const styles = {
        container: {
            paddingHorizontal: variant === "dialog" ? controlPaddings.medium : controlPaddings.small,
            borderTopColor: colors.content.border.subtle,
            marginHorizontal: -spaces.spacingXs,
            borderTopWidth: borders.separator,
            marginBottom: -spaces.spacingXs,
            height: controlHeights.medium,
            marginTop: spaces.spacingXs,
            gap: spaces.spacingMd
        } as Mutable<ViewStyle>,
        hint: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
